// extracted by mini-css-extract-plugin
export default {"heading_text":"HeadingText_heading_text__7s9gF"};